import React from 'react';

interface IProps {
  availableSeats: number;
  name: string;
  discription: string;
  price: number;
  color: string;
}

const PriceCategoryRow: React.SFC<IProps> = ({
  availableSeats,
  name,
  discription,
  price,
  color,
}) => { 
  if (!availableSeats) {
    return null;
  }
  return (
    <div style={ { backgroundColor: color } } className='price-category-row'>
      { name } - { discription } - { price } SEK
    </div>
  );
};

export default PriceCategoryRow;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/PriceCategoriesList/PriceCategoryRow.tsx